<div class="main-container mat-typography mat-body">
  <div class="card-container" [ngClass]="{'form-card-container' : primaryCareProviderOnly }">
    <div class="provider-container" [ngClass]="{'form-provider-container' : primaryCareProviderOnly }">

      <!-- Main Container -->
      <mat-card class="find-provider-card">

        <!-- Title -->
        <mat-card-title>
          <h2>{{title}} <small>{{subTitle}}</small></h2>
        </mat-card-title>

        <!-- Description -->
        <p>{{description}}</p>

        <form [formGroup]="form">
          <div class="flex-contents">

            <mat-form-field appearance="outline" class="search">
              <mat-label>Search for Doctors</mat-label>
              <input type="text" matInput formControlName="searchString" [matAutocomplete]="auto"
                placeholder="Enter minimum 3 characters" #inputAutoComplit>
              </mat-form-field>

              <mat-autocomplete #auto="matAutocomplete">
                @for (doctor of autoCompleteResults; track doctor) {
                  <mat-option class="doctor-option"
                    [value]="doctor.name">
                    <div class="doctor-result">
                      <div class="doctor-info">
                        <span>{{doctor?.name}}</span>
                        @if (doctor?.title) {
                          <small [innerHTML]="doctor?.title"></small>
                        }
                        @if (!doctor?.title) {
                          <br />
                        }
                        <small>{{doctor?.address}}</small>
                      </div>
                      <div class="doctor-action">
                        @if (!additionalInfoLoading) {
                          <button mat-raised-button color="primary" class="add-doctor" [disabled]="doctor.isSelected"
                            (click)="doctorAdded(doctor)">
                            {{ doctor.isSelected ? 'Added' : (selectedDoctors.length === 1 && primaryCareProviderOnly ? 'Replace' : 'Add') }}
                          </button>
                        }
                        @if (additionalInfoLoading) {
                          <mat-spinner [diameter]="20"></mat-spinner>
                        }
                      </div>
                    </div>
                    <mat-divider></mat-divider>
                  </mat-option>
                }
                @if (moreAutocompleteResultsAvailable) {
                  <div class="fetch-more">
                    <div class="spinner-container">
                      @if (showFetchMoreSpinner) {
                        <mat-spinner [diameter]="20"></mat-spinner>
                      } @else {
                        <button mat-button (click)="fetchMoreAutocompleteResults($event)" color="primary">Fetch More Results</button>
                      }
                    </div>
                  </div>
                }
              </mat-autocomplete>
              <mat-form-field appearance="outline" class="radius">
                @if (!primaryCareProviderOnly) {
                  <mat-label>Search Radius</mat-label>
                }
                @if (primaryCareProviderOnly) {
                  <mat-label>Within</mat-label>
                }
                <mat-select formControlName="radius">
                  @for (rad of radius; track rad) {
                    <mat-option [value]="rad.id">
                      {{rad.value}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="zipcode">
                <mat-label>ZipCode</mat-label>
                <input matInput formControlName="zipCode" placeholder="ex. 15221" maxlength="5">
              </mat-form-field>

              <div class="doctor-search">
                @if (showSpinner) {
                  <div>
                    <mat-spinner [diameter]="36"></mat-spinner>
                  </div>
                }
              </div>
            </div>
          </form>

          <!-- Selected Items -->
          <mat-card-content class="selected-doctors-container">
            <div class="button-and-errors">
              <div class="errors">
                <!-- ERRORS -->
                @if (autoCompleteResults.length == 0 && showNoResults) {
                  <mat-error class='no-doctors-found-msg'>
                    No providers found
                  </mat-error>
                }
                @if (minimumCharError) {
                  <mat-error>
                    Type at least 3 characters
                  </mat-error>
                }
              </div>
            </div>

            @if (selectedDoctors.length > 0) {
              <mat-divider></mat-divider>
            }

            @for (doctor of selectedDoctors; track doctor; let i = $index) {
              <div class="padded-item">
                <div class="doctor-result">
                  <div class="doctor-info">
                    <span>{{doctor?.name}}</span>
                    <small [innerHTML]="doctor?.title"></small>
                    <small>{{doctor?.address}}</small>
                  </div>
                  @if (doctor?.otherLocations?.length > 0) {
                    <div>
                      <mat-form-field appearance="outline" class="other-location">
                        <mat-label>Select other Location</mat-label>
                        <mat-select (selectionChange)="updateLocation(doctor, $event.value)">
                          @for (location of doctor?.otherLocations | addressFilter:doctor.locationId; track trackByLocationId($index, location)) {
                            <mat-option [value]="location">
                              {{location.displayDetails.address}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  <div class="doctor-action">
                    <button mat-raised-button color="primary" class="remove-doctor"
                    (click)="removeDoctor(doctor)">Remove</button>
                  </div>
                </div>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  @if (!primaryCareProviderOnly) {
    <div class="button-container">
      <a href="javascript:void(0)" (click)="navBack()">
        <span class="material-symbols-outlined">arrow_back</span>
        <span>BACK</span>
      </a>
      <button mat-raised-button color="primary" type="button" (click)="navForward()">
        {{ nextButtonLabel || 'Next' }}
      </button>
    </div>
  }
